/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class CustomerListModel extends JSONable {
  uuid: string | undefined = undefined;
  newCustomer: boolean | undefined = undefined;
  customerName: string | undefined = undefined;
  customerCity: string | undefined = undefined;
  customerCountry: string | undefined = undefined;
  territoryName: string | undefined = undefined;
  salesName: string | undefined = undefined;
  customerLastContactDate: Date | undefined = undefined;
  customerLoyaltyCode: string | undefined = undefined;
  customerStage: string | undefined = undefined;
  customerCreditStatus: string | undefined = undefined;
  customerIndustryType: string | undefined = undefined;
  globalAccountCode: string | undefined = undefined;
  globalAccountType: string | undefined = undefined;
  profileGpBrand: string | undefined = undefined;
  profileSalesChannel: string | undefined = undefined;
  favourite: boolean | undefined = undefined;
}
